import { Box, Container } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import MainAppBarComponent from "../components/appBars/MainAppBarComponent";
import AnnouncementCarouselComponent from "../components/carousel/AnnouncementCarouselComponent";
import { SampleFooterComponent } from "../components/footers/SampleFooterComponent";
import DownloadAppsPageComponent from "../components/pages/main/DownloadAppsPageComponent";
import { WaveShapeComponent } from "../components/shapes/WaveShapeComponent";

const UnavailablePage = () => {
  const { t, i18n } = useTranslation();
  return (
    <Container maxWidth="xl" disableGutters={true}>
      <MainAppBarComponent />
      <AnnouncementCarouselComponent />
      <Box paddingY={3} />
      <Box
        marginY={{ md: 5, xs: 2 }}
        paddingX={{ md: 7, xs: 2 }}
        position="relative"
      >
        <WaveShapeComponent />
        <DownloadAppsPageComponent title={t("dialogDownloadAppToContinue")} />
      </Box>
      <SampleFooterComponent />
    </Container>
  );
};

export default UnavailablePage;
